const roles = {
  ADMIN: 'ROLE_ADMIN',
  PROVINCE: 'ROLE_PROVINCE',
  DISTRICT: 'ROLE_DISTRICT',
  WARD: 'ROLE_WARD',
};

export default {
  roles: roles,
  authenSuccesUrlRedirect: function (hasAuthor) {
    if (hasAuthor(roles.ADMIN)) {
      return '/dashboard.html';
    } else {
      return '/dashboard.html';
    }
  },

  authorizationMapper: [
    // {
    //   regex: /^\/system-management*/,
    //   isAuthorized: function (hasAuthor) {
    //     return hasAuthor(roles.ADMIN);
    //   }
    // },
    {
      regex: /^\/system-management\/managed-system/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN);
      }
    },
    {
      regex: /^\/system-management\/action-log/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.PROVINCE);
      }
    },
    {
      regex: /^\/user-management\/managed-users/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.PROVINCE);
      }
    },
    {
      regex: /^\/user-management\/managed-position/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.PROVINCE);
      }
    },
    {
      regex: /^\/dashboard.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.PROVINCE) || hasAuthor(roles.DISTRICT) || hasAuthor(roles.WARD);
      }
    },
    // {
    //   regex: /^\/user\/*/,
    //   isAuthorized: function (hasAuthor) {
    //     return hasAuthor(roles.ADMIN);
    //   }
    // }
  ]
}
